import {defineStore} from "pinia";

import Configuration from "../configuration";

export const useSecurityStore = defineStore('security', {
    state: () => ({
        accessToken: null,
        userContext: {},
        authorities: {},
        version: null,

    }),
    actions: {
        getImageLink() {
            return `${Configuration.value("rootApi")}/images`;
        },
        setAccessToken(accessToken) {
            this.accessToken = accessToken;
        },
        setUserContext(userContext) {
            this.userContext = userContext;
        },
        setAuthorities(authorities) {
            this.authorities = authorities;
        },
        setVersion(version) {
            this.version = version;
        },
    },
});
